import type { Localized } from './site'
import cadillacFetch from './cadillac.txt?raw'
import asusFetch from './AsusDebian.txt?raw'
import dellFetch from './DellDebian.txt?raw'

const fetchLines = (output: string, prompt = false) => output.replace(/\r/g, '').trimEnd().split('\n').slice(prompt ? 1 : 0)

export const machines = [
  { slug: 'cadillac', role: { en: 'main workstation', ru: 'основная рабочая машина' }, specs: ['Intel Core i7-6800K', 'Radeon RX 7800 XT 16 GB', '32 GB RAM', 'Windows 11 Pro'], fetch: fetchLines(cadillacFetch, true) },
  { slug: 'asus', role: { en: 'node', ru: 'нода' }, specs: ['Ryzen 7 5800H', 'Radeon Vega + RTX 3050 Mobile', '16 GB RAM', 'Debian 12'], fetch: fetchLines(asusFetch) },
  { slug: 'dell', role: { en: 'node', ru: 'нода' }, specs: ['Intel i3-6006U', 'Radeon Mobile + Intel HD 520', '4 GB RAM', 'Debian 12'], fetch: fetchLines(dellFetch) },
] as const satisfies readonly { slug: string; role: Localized; specs: readonly string[]; fetch: readonly string[] }[]
